module.exports = __webpack_public_path__ + "static/media/clazbookslogo.78c3fce3.png";